import React from 'react';
import { fetchError } from "redux/actions";
import { EventManager } from "../event/manager";
import App from './app';

class ErrorCatch extends React.Component {

    selfError = "ErrorCatch报错";

    constructor(props) {
        super(props)
        this._event = new EventManager();
        ErrorCatch.current = this;
    }

    on(event, handle){ //event:事件名称
        this._event.on(event, handle);
    }

    off(event, handle){
        this._event.off(event, handle);
    }

    _raiseEvent(arg){
        return this._event.raise("error", arg, this);
    }

    _disposeEvent(){
        this._event.clear();
    }

    componentDidMount() {
        // event catch
        window.addEventListener('error', this.catchError, true);
        // async code
        window.addEventListener('unhandledrejection', this.catchRejectEvent, true);
    }

    componentWillUnmount() {
        window.removeEventListener('error', this.catchError, true)
        window.removeEventListener(
            'unhandledrejection',
            this.catchRejectEvent,
            true
        )
    }


    postError = (e) => {
        try {
            if(this._raiseEvent(e)===false) return;
            //如果没有被截获，那么进入默认处理流程
            const dispatch = App.dispatch();
            dispatch(fetchError(e.message));
            console.log(e);
        } catch (exception) {
            console.log(this.selfError + "onCatch", exception)
        }
    }

    catchError = (e) => {
        // e.stopPropagation();
        // e.preventDefault();
        try {
            const {
                colno,
                lineno,
                filename,
                type,
                message,
              } = e
            const obj = {
                caught_event: 'onerror',
                message,
                localtime: Date.now(),
                stack: `Error: at ${filename} ${lineno}:${colno}`,
                event_type: type,
                err_href: window.location.href,
            }
            this.postError(obj)
        } catch (e) {
            console.log(this.selfError + "catchError", e)
        }
    }

    catchRejectEvent = (error) => {
        try {
            const { type, reason } = error;
            let message,stack;
            if (typeof reason === "string") {
                message = reason;
            }
            if (Object.prototype.toString.call(reason) === '[object Error]') {
                message = reason.message;
                stack = JSON.stringify(reason);
                if (stack === "{}") { stack = reason.stack }
            }
            const obj = {
                caught_event: 'onunhandledrejection',
                message,
                localtime: Date.now(),
                stack,
                event_type: type,
                err_href: window.location.href,
            }
            this.postError(obj)
        } catch (error) {
            console.log(this.selfError + "catchRejectEvent", error)
        }
        error.stopPropagation()
    }

    render() {
        return this.props.children;
    }
}

export default ErrorCatch;

export function on(event, handle){
    ErrorCatch.current.on(event, handle);
}

export function off(event, handle){
    ErrorCatch.current.off(event, handle);
}